import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
// import ProductionOutputAction from "app/components/Accounting/ProductionOutput/ProductionOutputAction"

class ProductionProductionOutputActivity extends Component {
    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Accounting/ProductionOutput/ProductionOutputBrowser")
    }

    render() {
        return (
            <Activity 
                name="ProductionOutput"
                RenderedComponent={this.RenderedComponent}
                context="ProductionOutput"
                // formActions={ProductionOutputAction}
            />
        )
    }
}

export default ProductionProductionOutputActivity
